import React from 'react';

/**
 * Task progress bar showing completed vs total tasks.
 */
export default function ProgressBar({ completed, total, t }) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 13,
        color: '#8b949e',
        marginBottom: 6,
      }}>
        <span>{completed}/{total} {t?.completed || 'completed'}</span>
        <span>{pct}%</span>
      </div>
      <div style={{
        height: 8,
        background: '#30363d',
        borderRadius: 4,
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: `${pct}%`,
          background: pct === 100 ? '#00b894' : '#6c5ce7',
          borderRadius: 4,
          transition: 'width 0.3s ease',
        }} />
      </div>
    </div>
  );
}
